module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table-with-checkbox', {
    attrs: {
      "title": _vm.title,
      "sub-title": _vm.subtitle,
      "data": _vm.tableData,
      "columns-titles": _vm.tableColumnsTitles,
      "columns-values": _vm.tableColumnsValues
    },
    on: {
      "rowSelectedChange": _vm.onSelectChange
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d02115e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/ItemList.vue
// module id = 249
// module chunks = 3